<template>
  <div class="row marketing">
    <div class="col-lg-12">        
        <div style="text-align:center;margin-bottom:2em;">
          <span class="fa fa-check-circle fa-5x" style="color:#6AD5BF;"></span>
          <h4>Congratulations!</h4>
          <p>You earned 
          <span style="color:#f2c300; font-weight:bold;"> {{userLearningPoints}}<span style="color:rgba(242, 195, 0, .4)">/{{getLCData.assignmentPoints}}</span> 
          <span style="margin-top: -4px; margin-left: -4px;" class="coinicon3"></span></span>
          Learning Points.</p>
        </div>
        <div style="margin-bottom:1em">
         We hope that you enjoyed this learning community and learned some things about blockchain. Please take a minute and give us feedback on this course so we can improve it 
         <a style="font-weight:bold;color: rgba(0,0,0,.8);" target="_blank" href="https://goo.gl/forms/Up2C7Nfs8sS0WLto1">here</a>.
        </div>

      <div class=backgroundCert>
        <div class="contentCert">
          <img src="https://prototype.dacade.org/assets/img/logo2.svg" width="80" height="30" style="margin-bottom:1.2em;border:none!important">
          <!--<div style="margin-bottom: 1em;font-size: 1.2em;color: rgba(0,0,0,.5);letter-spacing: 2px;">CERTIFICATED GRADUATION</div>-->
          <div style="font-size: 0.8em;color: rgba(0,0,0,.2);">certifies that</div>
          <div style="margin-bottom: 0.2em;font-size: 1.2em;color: rgba(0,0,0,.7);">{{currentUserName}}</div>
          <div style="font-size: 0.8em;color: rgba(0,0,0,.2);">has successfully completed</div>
          <div style="margin-bottom: 0.8em;font-size: 1.2em;color: rgba(0,0,0,.7);">{{getLCData.name}}</div>
          <img src="https://prototype.dacade.org/assets/img/dacade_sign.png" width="80" height="80" style="margin-bottom:0.2em;">
          <hr>
          <div style="font-size: 0.8em; color: rgba(0,0,0,.2);">This is a certificate for completing the first prototype of the dacade learning communities. To learn more visit dacade.org. </div>
        </div>
      </div>
      <div style="margin:1em 0 2em 0em">
        <i style="color:rgba(0,0,0,.2); font-weight:bold">
          If you have any suggestions how we can improve this prototype, please get in touch with us on 
          <a style="color:rgba(0,0,0,.4)" href="https://t.me/dacade">telegram</a> or via email moritz@dacade.org! We are very grateful for all suggestions.
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../../store/store.js'

export default {
    data() {
        return {
        }
    },
    computed: {
      getLCData() {
        //console.log(parseInt(this.$route.params.courseId))
        //var chapterId = parseInt(this.$route.params.chapterId);
        var courseId = parseInt(this.$route.params.courseId)
        
        var courseData = this.$store.getters.getCurrentLCData2(courseId)
        return courseData
      },
      currentUserName(){
        return this.$store.getters.currentUser.displayName;
      },
      userLearningPoints(){
        var cUser = this.$store.getters.currentUser;
        var uC = this.$store.getters.getUserCollection;
        var learningPoints = 0
        if(uC && cUser){
            var userData = uC.filter( newData => {
                return  (newData.uid == cUser.uid );
            });
            if (userData.length>0){
              if (userData[0].learningPoints){
                learningPoints = Math.ceil(userData[0].learningPoints)
              }
            }
        }
        return learningPoints;
      }
    },
}
</script>

<style scoped>

.contentCert{
  padding: 1.8em 3em;
  background:rgba(255,255,255,.6);
  text-align:center;
  border-radius:.2rem;color:rgba(0,0,0,.6);
  box-shadow: 2px 2px 25px 0px rgba(46, 61, 73, 0.1);
}

@media (max-width: 575px) {
  .contentCert {
    padding: 1em;
    padding-top:2em;
  }
  .backgroundCert{
    padding: 1em;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/course/CourseCertificate.vue